import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './DrawerSectionHeader.module.scss';

interface DrawerSectionHeaderProps {
  title: ReactNode;
  description: ReactNode;
  rightNode?: ReactNode;
  className?: string;
}

/**
 * @deprecated
 */
export const DrawerSectionHeader = ({
  title,
  description,
  rightNode,
  className,
}: DrawerSectionHeaderProps) => {
  return (
    <div className={clsx(styles.root, className)}>
      <div className={styles.titleDescriptionWrapper}>
        <span className={styles.titleText}>{title}</span>
        <span className={styles.descriptionText}>{description}</span>
      </div>
      {rightNode}
    </div>
  );
};
